/*!
 * speed-optimizer.js
 * 1) Delays third-party app scripts (Google, Facebook, Interakt, Wigzo,
 *    Shiprocket) until first user interaction or after page load.
 * 2) Loads non-critical CSS without blocking first paint.
 *
 * Must run BEFORE {{ content_for_header }}, so load it synchronously
 * (no async / defer) as the first script inside <head>.
 */
(function () {
  'use strict';

  /* ================================================================
     SETTINGS - edit these
     ================================================================ */

  // Scripts whose URL or inline code contains any of these are delayed.
  var DELAY_SCRIPTS = [
    'googletagmanager.com',
    'google-analytics.com',
    'googleadservices.com',
    'connect.facebook.net',
    'fbq(',
    'gtag(',
    'interakt',
    'wigzo',
    'shiprocket'
    // 'judge.me',   // uncomment only if you accept reviews appearing late
    // 'jdgm'
  ];

  // Stylesheets (matched on URL) that will load without blocking render.
  // Keep base.css OUT of this list to avoid an unstyled flash.
  // Start with overflow-list.css only; add compiled_assets/styles.css
  // after checking on a phone that there is no unstyled flash.
  var NON_CRITICAL_CSS = [
    'overflow-list.css'
    // 'compiled_assets/styles.css'
  ];

  var TRIGGER_EVENTS = ['scroll', 'mousemove', 'touchstart', 'keydown', 'click'];
  var FALLBACK_MS = 3500; // release this long after the page "load" event

  /* ================================================================
     PART 1 - Non-blocking CSS
     ================================================================ */

  function matchesAny(str, list) {
    str = (str || '').toLowerCase();
    for (var i = 0; i < list.length; i++) {
      if (str.indexOf(list[i].toLowerCase()) !== -1) return true;
    }
    return false;
  }

  function makeCssNonBlocking(link) {
    if (link.getAttribute('data-sp-handled')) return;
    link.setAttribute('data-sp-handled', '1');
    var restore = function () { link.media = 'all'; link.onload = null; };
    link.media = 'print';
    link.onload = restore;
    setTimeout(restore, 4000); // safety net so styles always apply
  }

  /* ================================================================
     PART 2 - Delay third-party scripts
     ================================================================ */

  var queue = [];
  var released = false;

  function shouldDelayScript(node) {
    if (node.tagName !== 'SCRIPT') return false;
    var t = node.type;
    if (t && t !== 'text/javascript' && t !== 'application/javascript' && t !== 'module') return false;
    var haystack = node.src ? node.src : (node.textContent || '');
    return matchesAny(haystack, DELAY_SCRIPTS);
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (!node.tagName) return;

        // Stylesheets
        if (node.tagName === 'LINK' && node.rel === 'stylesheet' &&
            node.href && matchesAny(node.href, NON_CRITICAL_CSS)) {
          makeCssNonBlocking(node);
          return;
        }

        // Scripts
        if (!released && shouldDelayScript(node)) {
          queue.push({
            src: node.src || null,
            text: node.src ? null : node.textContent,
            attrs: Array.prototype.map.call(node.attributes, function (a) {
              return [a.name, a.value];
            })
          });
          node.type = 'javascript/blocked';
          if (node.parentNode) node.parentNode.removeChild(node);
        }
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  // Firefox: cancel execution of blocked scripts
  window.addEventListener('beforescriptexecute', function (e) {
    if (e.target.type === 'javascript/blocked') e.preventDefault();
  }, true);

  function release() {
    if (released) return;
    released = true;
    TRIGGER_EVENTS.forEach(function (ev) { window.removeEventListener(ev, release); });

    queue.forEach(function (item) {
      var s = document.createElement('script');
      item.attrs.forEach(function (a) {
        if (a[0] !== 'type') s.setAttribute(a[0], a[1]);
      });
      if (item.src) { s.src = item.src; s.async = false; }
      else { s.text = item.text; }
      document.head.appendChild(s);
    });
    queue = [];

    // Stop observing a moment later so late-added app scripts are not missed
    setTimeout(function () { observer.disconnect(); }, 100);
  }

  // Public hook: call window.releaseDelayedScripts() after cookie consent
  // if you want to load these only once consent is given.
  window.releaseDelayedScripts = release;

  TRIGGER_EVENTS.forEach(function (ev) {
    window.addEventListener(ev, release, { passive: true, once: true });
  });
  window.addEventListener('load', function () { setTimeout(release, FALLBACK_MS); });
})();